import React from "react";

import Hero from "../../components/AboutComponent/Hero";
import Expectation from "../../components/AboutComponent/Expectation";
import Counter from "../../components/AboutComponent/Counter";
import Testimonial from "../../components/AboutComponent/Testimonial";
import Header from "../../components/common/Header";
import Instructor from "../../components/AboutComponent/Instructor";
import FAQ from "../../components/AboutComponent/FAQ";
import EventSection from "../../components/AboutComponent/EventSection";
const About = () => {
  return (
    <div className="tracking-wide">
      <Header
        title="About"
        description="Collab Courses are designed to make learning engaging, flexible, and practical. With experienced mentors, interactive lessons, and real-world projects, learners gain hands-on experience and valuable industry insights. Our platform encourages collaboration through group activities and live sessions, helping students build skills that truly prepare them for future success."
        breadcrumbs={[
          { label: "HOME", path: "/" },
          { label: "ABOUT", path: "/about" },
        ]}
      />
      <Hero />
      <Expectation />
      <Counter />
      <Testimonial />
      <Instructor />
      <EventSection />
      <FAQ />
    </div>
  );
};

export default About;
